import React from "react";
import { Link } from "react-router-dom";
import "../css/main.scss";
import productData from "../Datas/productData";

function Main() {
  const toTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <div className="main">
      <main>
        <div className="hero-section">
          <img src="/main/main1.webp" alt="Hero" className="hero-image" />
        </div>

        <div className="featured-products">
          <div className="products-grid">
            {productData.map((product) => (
              <div key={product.id} className="product-card">
                <Link
                  to={`/shopDetails/${product.id}`}
                  className="product-link"
                  onClick={toTop}
                >
                  <div className="product-image-container">
                    <img
                      src={product.image}
                      alt={product.name}
                      className="product-image"
                    />
                  </div>
                  <div className="product-info">
                    <h3 className="product-name">{product.name}</h3>
                    <p className="product-price">${product.price} SGD</p>
                  </div>
                </Link>
              </div>
            ))}
          </div>
        </div>
      </main>
    </div>
  );
}

export default Main;
